<template>
    <div>
        <b-form @submit.prevent="search">
            <b-form-group>
                <b-input-group>
                    <b-form-input ref="search-term" type="search" placeholder="Search" v-model="search_term"/>
                    <b-input-group-append>
                        <b-btn type="submit" variant="outline-secondary" :disabled="searching">
                            <font-awesome-icon :icon="['fad', 'search']"/>
                        </b-btn>
                    </b-input-group-append>
                    <b-input-group-append v-if="searched">
                        <b-btn type="submit" variant="danger" @click.prevent="clearSearch">
                            <font-awesome-icon :icon="['fad', 'backspace']"/>
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-form>

        <div v-if="searched">
            <div v-if="searching" class="mb-3">
                <b-spinner label="Spinning"></b-spinner>
            </div>
            <div v-else>
                <b-list-group v-if="related_media && related_media.length" class="my-3">
                    <b-list-group-item
                        v-for="(item, index) in related_media"
                        :key="index"
                        class="d-flex align-items-center"
                    >
                        <related-media-item
                            :item="item"
                            @link="addInteractiveMediaLink($event, 'related-media')"
                        />
                    </b-list-group-item>
                </b-list-group>

                <b-alert
                    variant="danger"
                    :show="searched && (!related_media || related_media && !related_media.length)"
                >
                    0 results
                </b-alert>
            </div>
        </div>
        <div v-else>
            <b-list-group v-if="linked_related_media && linked_related_media.length">
                <b-list-group-item
                    v-for="(item, index) in linked_related_media"
                    :key="index"
                    v-if="item.pivot && article && (publication_id == item.pivot.publication_id) || panel"
                >
                    <div class="d-flex align-items-center">
                        <div class="mr-3">
                            <span v-if="item.title">
                                {{ item.title }}
                            </span>
                            <span v-else-if="item.name">
                                {{ item.name }}
                            </span>
                            <span v-else class="text-muted">
                                no title
                            </span>
                        </div>
                        <div class="ml-auto">
                            <b-link href="#" @click.prevent="addInteractiveMediaLink(item, 'related_media')">
                                <font-awesome-icon :icon="['fad', 'plus-square']"/>
                            </b-link>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>

        <b-alert
            variant="danger"
            :show="!searched && (!linked_related_media || linked_related_media && !linked_related_media.length)"
        >
            No linked Related Media
        </b-alert>
    </div>
</template>

<script>
import moment from 'moment'
import RelatedMediaItem from '@/components/modals/article/related_media/Item'

// Only SBP related media belongs in this tab; printables have their own tab.
const filterInvalidPanelMedia = (item) => item.related_media_id && item.type !== 'link' && item.merlin_id === undefined

// ensures panel media items still have their ids
const mapPanelMedia = (item) => ({
    ...item,
    id: item.related_media_id,
    title: item.title || item.name,
})

export default {
    data: () => ({
        related_media: [],
        linked_related_media: [],

        search_term: '',

        searching: false,
        searched: false,

        related_media_loading: true
    }),
    props: [
        'article',
        'publication_id',
        'panel',
    ],
    components: {
        RelatedMediaItem
    },
    watch: {},
    methods: {
        async getRelatedMedia() {
            if (!this.article) {
                if (this.panel) {
                    this.linked_related_media = (this.panel.media || [])
                        .filter(filterInvalidPanelMedia)
                        .map(mapPanelMedia)
                }

                return
            }

            try {
                this.related_media_loading = true
                const response = await this.axios.get('/api/articles/related_media/' + this.article.id)
                let related_media = []

                if (response.data) {
                    related_media = _.uniqBy(response.data, 'id')
                    related_media = _.orderBy(response.data, 'created')

                    this.linked_related_media = related_media
                }
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed load related media: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.related_media_loading = false
            }
        },
        async search() {
            if (!this.search_term) {
                return
            }
            this.searched = true
            this.searching = true

            try {
                this.related_media = []
                const response = await this.axios.get('/api/articles/search_related_media/' + this.search_term)

                if (response.data) {
                    this.related_media = response.data
                }
            } catch (e) {

            } finally {
                this.searching = false
            }

        },
        clearSearch() {
            this.search_term = ''

            this.searched = false
            this.searching = false
        },
        addInteractiveMediaLink(item, type) {
            this.$emit('add', item, type)
        }
    },
    mounted() {
        this.getRelatedMedia()
    }
}
</script>
